import styled from 'styled-components';
import { Avatar, Badge } from 'antd';
import { IoNotifications } from 'react-icons/io5';
import { AiOutlineUser } from 'react-icons/ai';
import { CredusText } from 'ui';

import CredusLogo from '../assets/images/png/credus-logo-white.png';
import { color } from 'ui';

const Header = () => {
  const firstName = localStorage.getItem('c-firstname');
  const lastName = localStorage.getItem('c-lastname');
  return (
    <Container>
      <img src={CredusLogo} alt="" style={{ marginLeft: '2.2rem' }} />
      <RightDiv>
        <Notification>
          <Badge dot>
            <IoNotifications />
          </Badge>
        </Notification>
        <User>
          <Avatar
            style={{ backgroundColor: '#87d068' }}
            icon={<AiOutlineUser />}
          />
          <CredusText size="md" weight="medium">
            {firstName} {lastName}
          </CredusText>
        </User>
      </RightDiv>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  width: 100vw;
  height: 72px;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  z-index: 110;
  padding: 1rem 2rem;
  padding-right: 3rem;
  background: ${color.white};
  border-bottom: 1px solid rgba(0, 9, 41, 0.15);
`;

const RightDiv = styled.div`
  display: flex;
  gap: 2rem;
`;

const Notification = styled.div`
  height: 27px;
  width: 27px;
  background: #eff0f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const User = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
